
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
import "../css/availabilities-rates.css";
import $$ from "Dom7";
import actions from "../js/actions.js";
import URLS from "../js/Urls.js";

var moment = require("moment");

export default {
  data: function () {
    return {
      loginResult: {},
      AvailParams: actions.GetAvailabilityParams(),
      eventItems: {}
    };
  },
  methods: {
    PriceForAll: function (rateid) {
      var num = $$(".GlobalRatePrice_" + rateid).val();
      $$(".RatePrice_" + rateid).each(function () {
        $$(this).val(num);
      });
    }
  },

  beforeDestroy() {
    var self = this;
  },

  on: {
    pageInit: async function (e, page) {
      var AvailParams = actions.GetAvailabilityParams();
      var loginResult = actions.LoginGetResult();
      $$("#CustomBack").on("click", function () {
        if (app.data.currentTab === 1) app.views.main.router.navigate("/main/");else if (app.data.currentTab === 2) app.views.main.router.navigate("/main/reservationscalendar/");else if (app.data.currentTab === 3) app.views.main.router.navigate("/main/reservations/");else if (app.data.currentTab === 4) app.views.main.router.navigate("/main/availabilities/");
      });
      var page = e.detail.page;
      var self = this;
      var app = self.$app;
      var $ = self.$;
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var initalizedates = [];
      initalizedates.push(new Date(AvailParams.FromDate));

      if (AvailParams.Todate != null) {
        initalizedates.push(new Date(AvailParams.Todate));
      }

      var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const Calendar = app.calendar.create({
        containerEl: "#roomstatus-calendar-price",
        rangePicker: true,
        value: initalizedates,
        weekHeader: false,
        disabled: [{
          from: new Date().minDate,
          to: yesterday
        }],
        renderToolbar: function () {
          return '<div class="toolbar calendar-custom-toolbar no-shadow calendarcustomtoolbar">' + '<div class="toolbar-inner">' + '<div class="left">' + '<a href="#" class="link icon-only"><i class="icon icon-back ' + (app.theme === "md" ? "color-black" : "") + '"></i></a>' + "</div>" + '<div class="center"></div>' + '<div class="right">' + '<a href="#" class="link icon-only"><i class="icon icon-forward ' + (app.theme === "md" ? "color-black" : "") + '"></i></a>' + "</div>" + "</div>" + "</div>";
        },
        on: {
          open: function (c) {
            var fromdate = AvailParams.FromDate;
            c.setYearMonth(fromdate.getFullYear(), fromdate.getMonth(), 0);
            c.update();
            var MyDate = c.value[0].getFullYear() + "-" + (c.value[0].getMonth() + 1) + "-" + c.value[0].getDate();
            var dateFrom = c.value[0];
            var dateTo = c.value[1] ?? null;
            Getdata(dateFrom, dateTo); //takis gia events

            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          },
          init: function (c) {
            $(".calendar-custom-toolbar .center").text(monthNames[c.currentMonth] + ", " + c.currentYear);
            $(".calendar-custom-toolbar .left .link").on("click", function () {
              c.prevMonth();
            });
            $(".calendar-custom-toolbar .right .link").on("click", function () {
              c.nextMonth();
            });
          },
          monthYearChangeStart: function (c) {
            var dateFrom = c.value[0];
            var dateTo = c.value[1] ?? null;
            Getdata(dateFrom, dateTo);
            $(".calendar-custom-toolbar .center").text(monthNames[c.currentMonth] + ", " + c.currentYear); //takis gia events

            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          }
        }
      });
      Calendar.on("change", myHandler);

      function myHandler(calendar, value) {
        var dateFrom = calendar.value[0];
        var dateTo = calendar.value[1] ?? null;
        Getdata(dateFrom, dateTo);
      }

      async function Getdata(dateFrom, dateTo, c) {
        var ResponseGetPriceData = {};
        ResponseGetPriceData = await actions.GetAvailPriceData(dateFrom, dateTo, AvailParams.RoomCatID);
        var events = [];
        self.$setState({
          eventItems: ResponseGetPriceData,
          loginResult: loginResult
        });
      }

      $(".buttonclass").on("click", function (e) {
        var temp = $("#priceall").val();
        $(".classname").val(temp);
      });
      $$("#PriceSaveBtn").on("click", function () {
        var i = 0;
        var RateList = [];
        $$(".classRateID").each(function () {
          let PaxPriceListm = new Array();
          var rateid = $$(this).attr("id");
          var minstayid = "#NumOfNights_" + rateid;
          var nights = $$(minstayid).val();
          $$(".RatePrice_" + rateid).each(function () {
            var price = $$(this).val();

            if (price != "") {
              var id = $$(this).attr("id");
              var parent_id = $(this).parent().attr("id");
              var adults = $$(this).attr("data-adults");
              var children = $$(this).attr("data-children");
              var obj = {
                RatePaxID: id,
                Price: price,
                Adults: adults,
                Children: children
              };
              PaxPriceListm.push(obj);
            }
          });

          if (PaxPriceListm.length > 0) {
            var Rateobj = {
              RateID: rateid,
              MinStay: nights,
              PaxPriceList: PaxPriceListm
            };
            RateList.push(Rateobj);
          }
        });

        try {
          let dateFrom = Calendar.value[0];
          let dateTo = Calendar.value[1] ?? dateFrom;
          var CpdateFrom = new Date(JSON.parse(JSON.stringify(dateFrom)));
          var CpdateTo = new Date(JSON.parse(JSON.stringify(dateTo)));
        } catch {}

        if (RateList.length == 0) {
          var toastCheckConnection = app.toast.create({
            text: "Any change happened",
            position: "center",
            closeTimeout: 1500
          }).open();
        } else {
          SetRoomPrices(CpdateFrom, CpdateTo, RateList);
        }

        $(".custnuminput").val("");
      });

      async function SetRoomPrices(DateFrom, DateTo, RateList) {
        var obj = {
          PropertyID: loginResult?.PropertyID,
          RoomCatID: AvailParams.RoomCatID,
          UserID: loginResult?.UserID,
          DateFrom: DateFrom,
          DateTo: DateTo,
          RateList: RateList
        };
        app.preloader.show();
        await app.request.promise.postJSON(URLS.SetPricePlan, {
          obj
        }).then(res => {
          console.log(res.data);
          app.preloader.hide();

          if (res.data == null) {
            app.preloader.hide();
            var toastCheckConnection = app.toast.create({
              text: "Error,check internet connection",
              position: "center",
              closeTimeout: 1500
            }).open();
          }

          app.dialog.alert(res.data.message, "Update", refresh);
        }).catch(() => {
          app.preloader.hide();
          var toastCheckConnection = app.toast.create({
            text: "Error,check internet connection",
            position: "center",
            closeTimeout: 1500
          }).open();
        });
      }

      function refresh() {
        Getdata(Calendar.value[0], Calendar.value[1]);
      }

      async function GetEventsdata(dateFrom, dateTo, c) {
        var ResponseGetMonthlyAvailabilityData = {};
        var obj = {
          PropertyID: loginResult?.PropertyID,
          UserID: loginResult?.UserID,
          DateFrom: dateFrom,
          DateTo: dateTo,
          RoomCategoryID: AvailParams.RoomCatID
        };
        app.preloader.show();
        var response = await app.request.promise.postJSON(URLS.GetMonthRoomsDetails, {
          obj
        });
        app.preloader.hide();
        var events = [];
        ResponseGetMonthlyAvailabilityData = response.data;
        ResponseGetMonthlyAvailabilityData.forEach(function (item) {
          var d = moment(item.DateStr, "DD/MM/YYYY").toDate();
          var obj = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            // hours: 21,
            // minutes: 0,
            color: item.Color
          };
          var re = /-?\d+/;
          events.push(obj);
        });
        Calendar.params.events = events;
        Calendar.update();
      }
    },

    pageBeforeRemove() {}

  },
  id: '56fc326a57',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=price-and-limits><!-- Top Navbar --><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# id=CustomBack class=link><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'PriceNLimits', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=right id=PriceSaveBtn style="margin-right: 10px"><span class=material-icons>save</span></div></div></div><!-- Scrollable page content--><div class="page-content availabilitiespage" style=overflow:hidden;><div id=roomstatus-calendar-price></div><div class=block style="margin:10px 0;"><div class=row><div class=card><div class="card-content card-content-padding takis" style="padding: 5px 16px;"><div class=row><div class=col-100><span><b>';
      r += c(ctx_1.loginResult?.PropertyName, ctx_1);
      r += '</b></span> <span style="float: right;"><b>';
      r += c(ctx_1.AvailParams.RoomCatDesc, ctx_1);
      r += '</b></span></div></div></div></div></div><div class=scrollableClass>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.eventItems, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=row style="padding-bottom: 50px;"><div class=card><div class="card-content card-content-padding takis"><div class=row><div class=col-100><span><b>';
          r += c(ctx_2.RateName, ctx_2);
          r += '</b></span><br><span class="badge blue classRateID" id=';
          r += c(ctx_2.RateID, ctx_2);
          r += '>';
          r += c(ctx_2.RateCode, ctx_2);
          r += '</span></div></div><div class=row style=position:relative;><div class=col-45><span style="position:absolute;bottom: 12px;"><b>Change Price For All</b></span></div><div class=col-30><div class="row currency" style="margin-top: -2px;"><span class="col-25 currency-symbol-pl" style="margin: auto; text-align: center">';
          r += c(ctx_2.Currency, ctx_2);
          r += '</span> <span class=col-75 style="border-left: 1px solid lightgrey;\r\n                          position: relative;"><div class="item-input-wrap pricecheck" id=';
          r += c(ctx_2.RateID, ctx_2);
          r += '><input id="" type=number class="custnuminput GlobalRatePrice_';
          r += c(ctx_2.RateID, ctx_2);
          r += '" name=currency style="min-height: var(--f7-input-height);\r\n                              width: 100%;" autofocus></div></span></div></div><div class=col-25><a class=buttonclass @click=PriceForAll(';
          r += c(ctx_2.RateID, ctx_2);
          r += ')><button class="col button button-outline" style="background-color: #0077ca; color: white">Apply</button></a></div></div><hr><div class=row><span>Prices</span><br></div>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Prices, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class="col-50 customcol" style="display: flex; margin-top: 0.5em"><div style="display: inline-flex"><div class=custicon><i class=material-icons>person </i><span>x ';
              r += c(ctx_3.Adults, ctx_3);
              r += '</span></div><div class=custicon><span class=customsvg></span> <span>x ';
              r += c(ctx_3.Children, ctx_3);
              r += '</span></div></div></div><div class=col-50><div class="row currency"><span class="col-25 currency-symbol-pl" style="margin: auto; text-align: center">';
              r += c(ctx_3.Currency, ctx_3);
              r += '</span> <span class=col-75 style="border-left: 1px solid lightgrey;position: relative;"><div class="item-input-wrap classname" id=';
              r += c(ctx_3.RateID, ctx_3);
              r += '>';
              r += Template7Helpers.if.call(ctx_3, ctx_2.BlockPriceEdit, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <input type=number class="custnuminput RatePrice_';
                  r += c(ctx_4.RateID, ctx_4);
                  r += ' RoomsPrice" placeholder=';
                  r += c(ctx_4.Price, ctx_4);
                  r += ' id=';
                  r += c(ctx_4.RatePaxID, ctx_4);
                  r += ' name=currency data-adults=';
                  r += c(ctx_4.Adults, ctx_4);
                  r += ' data-children=';
                  r += c(ctx_4.Children, ctx_4);
                  r += ' style="min-height: var(--f7-input-height);width: 100%;" autofocus disabled=disabled> ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <input type=number class="custnuminput RatePrice_';
                  r += c(ctx_4.RateID, ctx_4);
                  r += ' RoomsPrice" placeholder=';
                  r += c(ctx_4.Price, ctx_4);
                  r += ' id=';
                  r += c(ctx_4.RatePaxID, ctx_4);
                  r += ' name=currency data-adults=';
                  r += c(ctx_4.Adults, ctx_4);
                  r += ' data-children=';
                  r += c(ctx_4.Children, ctx_4);
                  r += ' style="min-height: var(--f7-input-height);width: 100%;" autofocus> ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div></span></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '<!-- end price --><hr><div class=row><div class="col-50 customcol"><span>Minimum Stay</span></div><div class=col-50><div class="row currency"><span class=col-35 style="margin: auto">Nights </span><span class=col-65 style="border-left: 1px solid lightgrey;position: relative;"><div class=item-inner><div class=item-input-wrap><input type=number placeholder=';
          r += c(ctx_2.MinStay, ctx_2);
          r += ' id=NumOfNights_';
          r += c(ctx_2.RateID, ctx_2);
          r += ' name=nights autofocus class=custnuminput style="min-height: var(--f7-input-height);width: 100%;"></div></div></span></div></div></div><hr></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><!---toobar bottom---><div class="fab fab-center-bottom color-blue">';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=#><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;"><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="toolbar tabbar toolbar-bottom"><div class=toolbar-inner><a href=/main/ class=tab-link data-route-tab-id=dashboard><i class=material-icons>dashboard </i><span class=tabbar-label>Dashboard</span> </a><a href=/main/reservationscalendar/ class=tab-link data-route-tab-id=reservationscalendar><i class=material-icons>date_range </i><span class=tabbar-label>';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> </a><a href="" class=tab-link data-route-tab-id=""><!-- <i class="icon f7-icons if-not-md">email_fill</i>\r\n                                <i class="icon material-icons md-only">email</i> --> <span class=tabbar-label></span> </a><a href=/main/reservations/ class=tab-link data-route-tab-id=reservations><!-- <i class="icon f7-icons if-not-md">email_fill</i>\r\n                              <i class="icon material-icons md-only">email</i> --> <i class=material-icons>list </i><span class=tabbar-label>Reservations</span> </a>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableAvailabilities, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=/main/availabilities/ class=tab-link data-route-tab-id=availabilities><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;" class=tab-link><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="tabs tabs-routable"><div class="tab page-content" id=dashboard></div><div class="tab page-content" id=reservations></div><div class="tab page-content" id=addbtn></div><div class="tab page-content" id=availabilities></div><div class="tab page-content" id=reservationscalendar></div></div></div>';
      return r;
    }(this);
  },

  style: `
  #classRateID {
    margin-top: 5px;
  }

  .page-content.availabilitiespage .scrollableClass {
    height: calc(100vh - 505px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .custnuminput {
    text-align: center !important;
  }

  .row {
    margin: 2px;
  }

  .custicon {
    padding: 2px;
  }

  .customsvg {
    display: inline-flex;
    width: 1em;
    height: 1em;
    background-image: url(/static/images/child.svg);
    background-repeat: no-repeat, repeat;
    background-position: center;
    background-size: cover;
    font-size: 24px;
  }
`,
  styleScoped: false
};
    